/// <amd-module name="SuiteCommerce.PagePrinter.PrintableLayout.PrintableLayout.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.PrintableLayout.PrintableLayout.View", ["require", "exports", "Backbone", "sc-pageprinter-printable-layout.tpl", "SuiteCommerce.PagePrinter.Instrumentation"], function (require, exports, Backbone_1, sheetTemplate, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PrintableLayoutView = /** @class */ (function (_super) {
        __extends(PrintableLayoutView, _super);
        function PrintableLayoutView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = sheetTemplate;
            _this.counterMatrixChildItemsRemoved = 0;
            _this.events = {
                'click [data-target-removable-section]': 'removeSection',
            };
            return _this;
        }
        PrintableLayoutView.prototype.removeSection = function (event) {
            var removableSectionPrefix = 'data-removable-section-id';
            var targetSectionName = this.$el.find(event.target).data('targetRemovableSection');
            var targetSection = this.$el.find("[" + removableSectionPrefix + "=" + targetSectionName + "]");
            if (targetSection) {
                if (targetSectionName.match(/(combinations(?!((\-|\_)row)))/)) {
                    this.logMatrixChildSectionRemoved();
                }
                if (targetSectionName.match(/combinations(?=(\-|\_)row)/)) {
                    if (this.counterMatrixChildItemsRemoved === 0) {
                        this.setListenerLogMatrixChildItemRemoved();
                    }
                    this.counterMatrixChildItemsRemoved += 1;
                }
                targetSection.detach();
            }
        };
        Object.defineProperty(PrintableLayoutView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'PrintableArea.View': function () {
                        return _this.printableView;
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        PrintableLayoutView.prototype.render = function () {
            this.hidePageFromSEO();
            if (this.isUsedAnAlternativeTemplate()) {
                this.setAlternativeTemplateToPrintableView();
            }
            return _super.prototype.render.call(this);
        };
        PrintableLayoutView.prototype.isUsedAnAlternativeTemplate = function () {
            return this.template !== sheetTemplate;
        };
        PrintableLayoutView.prototype.setAlternativeTemplateToPrintableView = function () {
            this.printableView.template = this.template;
            this.template = sheetTemplate;
        };
        PrintableLayoutView.prototype.hidePageFromSEO = function () {
            $('head').append("<meta name=\"robots\" content=\"nofollow,noindex\">");
        };
        PrintableLayoutView.prototype.logMatrixChildSectionRemoved = function () {
            var log = Instrumentation_1.default.getLog('removeMatrixChildSection');
            log.setParameters({
                activity: 'Remove Matrix Child Section',
            });
            log.submit();
        };
        PrintableLayoutView.prototype.setListenerLogMatrixChildItemRemoved = function () {
            var _this = this;
            $(window).on("beforeprint", function () {
                if (_this.counterMatrixChildItemsRemoved > 0) {
                    var log = Instrumentation_1.default.getLog('removeMatrixChildItem');
                    log.setParameters({
                        activity: 'Remove Matrix Child Items',
                        instanceCount: _this.counterMatrixChildItemsRemoved,
                    });
                    log.submit();
                }
            });
        };
        return PrintableLayoutView;
    }(Backbone_1.View));
    exports.PrintableLayoutView = PrintableLayoutView;
});
